import "./src/styles/all.scss";
require("prismjs/themes/prism-tomorrow.min.css");
